export default function markAsDeletedInBasket({ props, state }) {
  const { medias } = props.payload // delete files from backend
  const { basketItems } = state.get('basket') // all basket items
  // make it array of ids
  const deletedIds = medias.map(media => {
    return media.id
  })
  // get the basket map id as array
  const mediaIds = Object.keys(basketItems).reduce((acc, key) => {
    const item = basketItems[key]
    if (deletedIds.indexOf(item.id) !== -1) {
      acc.push(key)
    }
    return acc
  }, [])

  // mark as deleted
  mediaIds.forEach(id => {
    state.set(`basket.basketItems.${id}.deleted`, true)
  })
}



// WEBPACK FOOTER //
// ./src/modules/Socket/actions/markAsDeletedInBasket.js